const part = [
    {
        path: 'bank-record-list',
        name: 'bank-record-list',
        meta: {
            icon: 'md-stats',
            title: '会员充值记录',
            notCache: true,
            access: ['S', 'I', 'I2'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/bank-record/bank-record-list')
    }
];

export default part;
